import { render, staticRenderFns } from "./vc-avatar.vue?vue&type=template&id=139257f7&scoped=true&"
import script from "./vc-avatar.vue?vue&type=script&lang=js&"
export * from "./vc-avatar.vue?vue&type=script&lang=js&"
import style0 from "./vc-avatar.vue?vue&type=style&index=0&id=139257f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139257f7",
  null
  
)

export default component.exports